"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.components = void 0;
var _accordionListItem = _interopRequireDefault(require("./accordionListItem"));
var _avatar = _interopRequireDefault(require("./avatar"));
var _button = _interopRequireDefault(require("./button"));
var _card = _interopRequireDefault(require("./card"));
var _cardListItem = _interopRequireDefault(require("./cardListItem"));
var _checkbox = _interopRequireDefault(require("./checkbox"));
var _chip = _interopRequireDefault(require("./chip"));
var _form = _interopRequireDefault(require("./form"));
var _formElements = _interopRequireDefault(require("./formElements"));
var _heading = _interopRequireDefault(require("./heading"));
var _image = _interopRequireDefault(require("./image"));
var _input = _interopRequireDefault(require("./input"));
var _label = _interopRequireDefault(require("./label"));
var _link = _interopRequireDefault(require("./link"));
var _list = _interopRequireDefault(require("./list"));
var _listItem = _interopRequireDefault(require("./listItem"));
var _radio = _interopRequireDefault(require("./radio"));
var _tab = _interopRequireDefault(require("./tab"));
var _table = _interopRequireDefault(require("./table"));
var _tableBody = _interopRequireDefault(require("./tableBody"));
var _tableCell = _interopRequireDefault(require("./tableCell"));
var _tableFooter = _interopRequireDefault(require("./tableFooter"));
var _tableHeader = _interopRequireDefault(require("./tableHeader"));
var _tableHeading = _interopRequireDefault(require("./tableHeading"));
var _tableRow = _interopRequireDefault(require("./tableRow"));
var _text = _interopRequireDefault(require("./text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1vjbzp0bs1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts";
  var hash = "d72aba007ba12d244f32afd0298ae841716ae826";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 59,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d72aba007ba12d244f32afd0298ae841716ae826"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjbzp0bs1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vjbzp0bs1();
var components = exports.components = (cov_1vjbzp0bs1().s[0]++, {
  AccordionListItem: _accordionListItem["default"],
  Avatar: _avatar["default"],
  Button: _button["default"],
  Card: _card["default"],
  CardListItem: _cardListItem["default"],
  Checkbox: _checkbox["default"],
  Chip: _chip["default"],
  Form: _form["default"],
  Heading: _heading["default"],
  Image: _image["default"],
  Input: _input["default"],
  Label: _label["default"],
  Link: _link["default"],
  List: _list["default"],
  ListItem: _listItem["default"],
  Radio: _radio["default"],
  FormElements: _formElements["default"],
  Tab: _tab["default"],
  Table: _table["default"],
  TableBody: _tableBody["default"],
  TableCell: _tableCell["default"],
  TableFooter: _tableFooter["default"],
  TableHeading: _tableHeading["default"],
  TableHeader: _tableHeader["default"],
  TableRow: _tableRow["default"],
  Text: _text["default"]
});